import React, { Component } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import RestrictedRoute from './RestrictedRoute'
import LoginPage from '../components/Login/LoginPage'
import Dashboard from '../components/Dashboard/Dashboard'
import ManageDailyOrders from '../components/DailyOrders/ManageDailyOrders/ManageDailyOrders'
import ManageOrderDetails from '../components/DailyOrders/ManageDailyOrders/ManageOrderDetails/ManageOrderDetails'
import PaymentStatusReport from '../components/DailyOrders/PaymentStatusReport/PaymentStatusReport'
import OrderShopDetails from '../components/DailyOrders/PaymentStatusReport/OrderShopDetails/OrderShopDetails'
import vizLinkJobsList from '../components/VizlinkShops/JobsList/JobsList'
import JobDetails from '../components/VizlinkShops/JobsList/JobDetails/JobDetails'
import vizLinkShopsOnBoardingDetails from '../components/VizlinkShops/OnBoardingShops/OnBoardingShops'
import VizLinkShopsList from '../components/VizlinkShops/VizShopsList/VizShopsList'
import PublicRoute from './PublicRoutes'
import ResetPassword from '../components/Login/ResetPassword'
import QrTillList from '../components/QrTillDetails/QrTillList/QrTillList'
import DeliverymanUserRegistration from '../components/QrTillDetails/DeliverymanUserRegistration/DeliverymanUserRegistration'
import OnBoardingAgentsList from '../components/VizlinkAgents/OnBoardingAgentsList/OnBoardingAgentsList'
import RegisteredAgentsList from '../components/VizlinkAgents/RegisteredAgentsList/RegisteredAgentsList'
import TillNumberDetails from '../components/QrTillDetails/TillNumberDetails/TillNumberDetails'
import DailyCollectionsReport from '../components/QrTillDetails/DailyCollectionsReport/DailyCollectionsReport'
import DeliveryManCoinsPaymentReport from '../components/VlLoyaltyProgram/DeliveryManCoinsPaymentReport/DeliveryManCoinsPaymentReport'
import DailyTransactionsSummary from '../components/Reports/DailyTransactionsSummary/DailyTransactionsSummary'
import UsersStatus from '../components/Reports/UsersStatus/UsersStatus'

import DistributorCoinsPaymentReport from '../components/VlLoyaltyProgram/DistributorCoinsPaymentReport/DistributorCoinsPaymentReport'
import VLCCommunicationListing from '../components/VLConnect/VLCShopkeeperTickets/VLCCommunicationListing'
import DistributorInbox from '../components/VLConnect/DistributorInbox/DistributorInbox'
import ConnectConversation from '../components/VLConnect/ConnectConversation/ConnectConversation'
import DLMCollectionReport from '../components/DailyOrders/DLMCollectionReport/DLMCollectionReport'
import ShopwiseTransactionsDetails from '../components/Reports/ShopwiseTransactionsDetails/ShopwiseTransactionsDetails'
import DigitalCollectionsReport from '../components/Reports/DigitalCollectionsReport/DigitalCollectionsReport'
import LoanDisbursementReport from '../components/LoanPayments/LoanDisbursementReport/LoanDisbursementReport'
import RsoJobDetails from '../components/VizlinkShops/OnBoardingShops/RsoJobDetails/RsoJobDetails'
import Sectors from '../components/VizlinkShops/Sectors/Sectors'
import SectorBasedReport from '../components/VizlinkShops/SectorBasedReport/SectorBasedReport'
import InvoiceAllocationListing from '../components/DailyOrders/InvoiceAllocationListing/InvoiceAllocationListing'
// import SchemesList from '../components/VlLoyaltyProgram/SchemesList/SchemesList'
import CoinsHistoryReport from '../components/VlLoyaltyProgram/CoinsHistoryReport/CoinsHistoryReport'
import DistributorConisDisbursmentReport from '../components/VlLoyaltyProgram/DistributorConisDisbursmentReport/DistributorConisDisbursmentReport'
import FinjaLoanReport from '../components/Reports/FinjaLoanReport/FinjaLoanReport'
import InvoiceWiseDailyCollectionDetails from '../components/M2DReorts/InvoiceWiseDailyCollectionDetails/InvoiceWiseDailyCollectionDetails'
import InvoiceWisePaymentBreakup from '../components/M2DReorts/InvoiceWisePaymentBreakup/InvoiceWisePaymentBreakup'
import Advertisements from '../components/Advertisements/Advertisements'
import RsoDetailsReport from '../components/Reports/RsoDetailsReport/RsoDetailsReport'
import RsoPerformanceReport from '../components/Reports/RsoPerformanceReport/RsoPerformanceReport'
import ShopWisePulseReport from '../components/Reports/AppPulse/ShopWisePulseReport/ShopWisePulseReport'
import DateWiseShopsSummaryReport from '../components/Reports/AppPulse/DateWiseShopsSummaryReport/DateWiseShopsSummaryReport'
import About from '../components/About/About'
import ShopsDetailReport from '../components/Reports/ShopsDetailReport/ShopsDetailReport'
import DisputedTransactionsReport from '../components/Reports/DisputedTransactionsReport/DisputedTransactionsReport'
import monthWiseM2DReport from '../components/M2DReorts/monthWiseM2DReport/monthWiseM2DReport'
import SCRDetailReport from '../components/DailyOrders/SCRDetailReport/SCRDetailReport'
import SCRCompleteDetailReport from '../components/DailyOrders/SCRDetailReport/SCRCompleteDetailReport/SCRCompleteDetailReport'
import SCRSummaryReport from '../components/DailyOrders/SCRDetailReport/SCRSummaryReport/SCRSummaryReport'
import KycApprovalListForMuawin from '../components/KYC/KycApprovalListForMuawin/KycApprovalListForMuawin'
import InvoiceAllocationListingDetail from '../components/DailyOrders/InvoiceAllocationListing/InvoiceAllocationListingDetail'
import InvoiceReopeningListing from '../components/DailyOrders/InvoiceReopeningListing/InvoiceReopeningListing'
import InvoiceReopeningListingDetail from '../components/DailyOrders/InvoiceReopeningListing/InvoiceReopeningListingDetail'
import SCRReport from '../components/DailyOrders/SCRReport/SCRReport'
import DlmUniqueShopsDetailReport from '../components/DeliverymanReports/UniqueShopsDetailReport/DlmUniqueShopsDetailReport'
import DeliverymanUniqueShopsReport from '../components/DeliverymanReports/DeliverymanUniqueShopsReport/DeliverymanUniqueShopsReport'
import VizShopsRequestListing from '../components/VizlinkShops/VizShopsRequestList/VizShopsRequestListing'
import LoanKycReport from '../components/LendingReports/LoanKycReport/LoanKycReport'
import LoanRepaymentReport from '../components/LendingReports/LoanRepaymentReport/LoanRepaymentReport'
import DisbursementFormList from '../components/Financing/DisbursementFormList/DisbursementFormList'
import DisbursementRejectionReport from '../components/LendingReports/DisbursementRejectionReport/DisbursementRejectionReport'
import VFOVisitList from '../components/VFOVisitList/VFOVisitList'
import VFODailyVistSummaries from '../components/VFOVisitList/VFODailyVistSummaries/VFODailyVistSummaries'
import FinancingLedgerReport from '../components/LendingReports/FinancingLedgerReport/FinancingLedgerReport'
import CBDataSharingForm from '../components/KYC/CBDataSharing/CBDataSharingForm'
import ProfileSetting from '../components/Settings/UserMenu/ProfileSetting/ProfileSetting'
import ChangePassword from '../components/Settings/UserMenu/ChangePassword/ChangePassword'
import OneBillPaymentReport from '../components/M2DReorts/OneBillPaymentReport/OneBillPaymentReport'
import TransactionReopeningListing from '../components/DailyOrders/TransactionReopeningListing/TransactionReopeningListing'
import DLMWiseBankDepositReport from '../components/DailyOrders/DLMWiseBankDepositReport/DLMWiseBankDepositReport'
import BankWiseDepositReport from '../components/DailyOrders/BankWiseDepositReport/BankWiseDepositReport'
import ShopKeeperInformationList from '../components/WhiteListing/ShopKeeperInformation/ShopKeeperInformationList'
import ShopTransactionalData from '../components/WhiteListing/ShopTransactionalData/ShopTransactionalData'

import MBLDistributorOnboardingList from '../components/MBLDistributorOnboarding/MBLDistributorOnboardingList'
import VLConnectDetailReport from "../components/VLConnect/VLConnectDetailReport/VLConnectDetailReport"
import VLConnectActivityReport from '../components/VLConnect/VLConnectActivityReport/VLConnectActivityReport' 
import VLConnectSummaryReport from '../components/VLConnect/VLConnectSummaryReport/VLConnectSummaryReport'
import monthWiseM2DDetailReport from '../components/M2DReorts/monthWiseM2DDetailReport/monthWiseM2DDetailReport'

import KYCListingForm from '../components/Financing/KYCListingForm/KYCListingForm'
class DistributorUserRoutes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      auth: false,
      clientCookie: false,
      logout: false,
    }
  }

  render() {
    return (
      <Switch>
        {/* <Redirect strict exact from='/' to='/dashboard' /> */}
        <PublicRoute
          restricted={true}
          component={LoginPage}
          path='/login'
          exact
        />
        <RestrictedRoute component={Dashboard} path='/dashboard' exact />

        <RestrictedRoute
          component={ManageDailyOrders}
          path='/NewOrdersForm'
          exact
        />
        <RestrictedRoute
          component={ManageOrderDetails}
          path='/ManageOrderDetails/:deliveryDate/:distCenterId'
          exact
        />
        <RestrictedRoute
          component={PaymentStatusReport}
          path='/PaymentStatusReport'
          exact
        />
        <RestrictedRoute
          component={OrderShopDetails}
          path='/OrderShopDetails/:deliveryDate/:distCenterId'
          exact
        />

        <RestrictedRoute
          component={Sectors}
          path='/sectors'
          exact
        />

        <RestrictedRoute
          component={SectorBasedReport}
          path='/SectorBasedReport'
          exact
        />


        {/* <RestrictedRoute
          component={vizLinkJobsList}
          path='/vizLinkJobsList'
          exact
        /> */}

        <RestrictedRoute
          component={VizShopsRequestListing}
          path='/VizShopsRequestListing'
          exact
        />

        {/* <RestrictedRoute component={JobDetails} path='/JobDetails/:id' exact />
        <RestrictedRoute
          component={vizLinkShopsOnBoardingDetails}
          path='/vizLinkShopsOnBoardingDetails'
          exact
        /> */}
        <RestrictedRoute
          component={RsoJobDetails}
          path='/RsoJobDetails/:id/:rsoId'
          exact
        />
        <RestrictedRoute
          component={VizLinkShopsList}
          path='/vizLinkShopsList'
          exact
        />
        <RestrictedRoute component={QrTillList} path='/QrTillList' exact />
        <RestrictedRoute
          component={DeliverymanUserRegistration}
          path='/DeliverymanUserRegistration'
          exact
        />

        {/* <RestrictedRoute
          component={OnBoardingAgentsList}
          path='/VizAgentsList'
          exact
        />
        <RestrictedRoute
          component={RegisteredAgentsList}
          path='/RegisteredAgentsList'
          exact
        /> */}
        <RestrictedRoute
          component={TillNumberDetails}
          path='/TillNumberDetails'
          exact
        />

        <RestrictedRoute
          component={DailyCollectionsReport}
          path='/DailyCollectionsReport'
          exact
        />
        <RestrictedRoute
          component={DeliveryManCoinsPaymentReport}
          path='/DeliveryManCoinsPaymentReport'
          exact
        />
        <RestrictedRoute
          component={DistributorCoinsPaymentReport}
          path='/DistributorCoinsPaymentReport'
          exact
        />
        <RestrictedRoute
          component={LoanDisbursementReport}
          path='/LoanDisbursementReport'
          exact
        />
        <RestrictedRoute
          component={FinjaLoanReport}
          path='/FinjaLoanReport'
          exact
        />

        <RestrictedRoute
          component={InvoiceWiseDailyCollectionDetails}
          path='/InvoiceWiseDailyCollectionDetails'
          exact
        />

        <RestrictedRoute
          component={InvoiceWisePaymentBreakup}
          path='/InvoiceWisePaymentBreakup'
          exact
        />

        <RestrictedRoute
          component={OneBillPaymentReport}
          path='/1BillPaymentReport'
          exact
        />

        <RestrictedRoute
          component={Advertisements}
          path='/Advertisements'
          exact
        />

        <RestrictedRoute
          component={VLCCommunicationListing}
          path='/VLCCommunicationListing'
          exact
        />
        <RestrictedRoute
          component={ConnectConversation}
          path='/ConnectConversation'
          exact
        />

        <RestrictedRoute
          component={DistributorInbox}
          path='/DistributorInbox'
          exact
        />

        <RestrictedRoute
          component={ShopwiseTransactionsDetails}
          path='/ShopwiseTransactionsDetails'
          exact
        />
        <RestrictedRoute
          component={DLMCollectionReport}
          path='/DLMCollectionReport'
          exact
        />
        <RestrictedRoute
          component={DLMWiseBankDepositReport}
          path='/DLMWiseBankDepositReport'
          exact
        />
        <RestrictedRoute
          component={BankWiseDepositReport}
          path='/BankWiseDepositReport'
          exact
        />
        <RestrictedRoute
          component={ShopTransactionalData}
          path='/ShopTransactionalData'
          exact
        />

        <RestrictedRoute
          component={InvoiceAllocationListing}
          path='/InvoiceAllocationListing'
          exact
        />

        <RestrictedRoute
          component={InvoiceAllocationListingDetail}
          path='/InvoiceAllocationListingDetail'
          exact
        />

        {/* <RestrictedRoute
          component={SchemesList}
          path='/SchemesList'
          exact /> */}

        <RestrictedRoute
          component={CoinsHistoryReport}
          path='/CoinsHistoryReport'
          exact
        />
        <RestrictedRoute
          component={DistributorConisDisbursmentReport}
          path='/DistributorCoinsDisbursmentReport'
          exact
        />
        <RestrictedRoute
          component={DailyTransactionsSummary}
          path='/DailyTransactionsSummary'
          exact
        />
        <RestrictedRoute
          component={UsersStatus}
          path='/UserDetailsReport'
          exact
        />
        <RestrictedRoute
          component={RsoDetailsReport}
          path='/RsoDetailsReport'
          exact
        />
        <RestrictedRoute
          component={RsoPerformanceReport}
          path='/RsoPerformanceReport'
          exact
        />
        <RestrictedRoute
          component={ShopWisePulseReport}
          path='/ShopWisePulseReport'
          exact
        />
        <RestrictedRoute component={About} path='/About' exact />
        <RestrictedRoute
          component={DateWiseShopsSummaryReport}
          path='/DateWiseShopsSummaryReport'
          exact
        />
        <RestrictedRoute
          component={DigitalCollectionsReport}
          path='/DigitalCollectionsReport'
          exact
        />
        <RestrictedRoute
          component={ShopsDetailReport}
          path='/ShopsDetailReport'
          exact
        />
        <RestrictedRoute
          component={DisputedTransactionsReport}
          path='/DisputedTransactionsReport'
          exact
        />
        <RestrictedRoute
          component={monthWiseM2DReport}
          path='/monthWiseM2DReport'
          exact
        />

        <RestrictedRoute
          component={monthWiseM2DDetailReport}
          path='/monthWiseM2DDetailReport'
          exact
        />

        <RestrictedRoute
          component={SCRDetailReport}
          path='/SCRDetailReport'
          exact
        />
        <RestrictedRoute
          component={SCRCompleteDetailReport}
          path='/SCRCompleteDetailReport'
          exact
        />
        <RestrictedRoute
          component={SCRSummaryReport}
          path='/SCRSummaryReport'
          exact
        />
        <RestrictedRoute
          component={KycApprovalListForMuawin}
          path='/KycApprovalListForMuawin'
          exact
        />

        <RestrictedRoute
          component={InvoiceReopeningListing}
          path='/InvoiceReopeningListing'
          exact
        />

        <RestrictedRoute
          component={TransactionReopeningListing}
          path='/TransactionReopeningListing'
          exact
        />

        <RestrictedRoute
          component={SCRReport}
          path='/SCRReport'
          exact
        />
        <RestrictedRoute
          component={DeliverymanUniqueShopsReport}
          path='/DeliverymanUniqueShopsReport'
          exact
        />

        <RestrictedRoute
          component={DlmUniqueShopsDetailReport}
          path='/DlmUniqueShopsDetailReport'
          exact
        />

        <RestrictedRoute
          component={ShopKeeperInformationList}
          path='/ShopKeeperInformationList'
          exact
        />

        <RestrictedRoute
          component={LoanKycReport}
          path='/LoanKycReport'
          exact
        />

        <RestrictedRoute
          component={MBLDistributorOnboardingList}
          path='/MBLDistributorOnboardingList'
        />

        <RestrictedRoute
          component={LoanRepaymentReport}
          path='/LoanRepaymentReport'
          exact
        />

        <RestrictedRoute
          component={KYCListingForm}
          path='/KYCListingForm'
          exact />

        <RestrictedRoute
          component={DisbursementFormList}
          path='/DisbursementFormList'
          exact
        />

        <RestrictedRoute
          component={DisbursementRejectionReport}
          path='/DisbursementRejectionReport'
          exact
        />

        <RestrictedRoute
          component={VFOVisitList}
          path='/VFOVisitList'
          exact
        />
        <RestrictedRoute
          component={VFODailyVistSummaries}
          path='/VFODailyVistSummaries/:vfoId/:visitDate'
          exact
        />

        <RestrictedRoute
          component={FinancingLedgerReport}
          path='/FinancingLedgerReport'
          exact
        />

        <RestrictedRoute
          component={CBDataSharingForm}
          path='/CBDataSharingForm'
          exact
        />

        <RestrictedRoute
          component={ProfileSetting}
          path='/ProfileSetting'
          exact
        />

        <RestrictedRoute
          component={ChangePassword}
          path='/ChangePassword'
          exact
        />

                <RestrictedRoute
          component={VLConnectDetailReport}
          path='/VLConnectDetailReport'
          exact
        />

        <RestrictedRoute
        component={VLConnectActivityReport}
        path='/VLConnectActivityReport'
        exact
        />
        
        <RestrictedRoute
        component={VLConnectSummaryReport}
        path='/VLConnectSummaryReport'
        exact
        />

        <PublicRoute path='*'>
          <Redirect to='/' />
        </PublicRoute>
      </Switch>
    )
  }
}

export default DistributorUserRoutes
